/**
 * Blueprint for the affiliate part of ticketing object.
 */
export class TicketingAffiliate {
  public companyId: string;
  public title: string;

  constructor(data?: any) {
    this.companyId = data.companyId;
    this.title = data.title;
   }

}
